import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { GoogleLogo } from "@phosphor-icons/react";

export default function Login() {
  const { loginWithEmail, loginWithGoogle } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await loginWithEmail(email, password);
      toast.success("Hoş geldiniz");
      nav("/panelim");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Giriş başarısız");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="login-page">
      <div className="border border-stone-200 bg-white p-8">
        <p className="text-xs uppercase tracking-[0.3em] font-bold text-stone-500 mb-2">Giriş</p>
        <h1 className="font-display text-3xl font-black tracking-tighter mb-8">Tekrar hoş geldin.</h1>

        <button
          onClick={loginWithGoogle}
          data-testid="google-login-btn"
          className="w-full border border-stone-950 bg-white text-stone-950 px-4 py-3 font-bold flex items-center justify-center gap-3 hover:bg-stone-950 hover:text-white transition-colors"
        >
          <GoogleLogo size={18} weight="bold" /> Google ile devam et
        </button>

        <div className="flex items-center gap-3 my-6">
          <span className="flex-1 border-t border-stone-200" />
          <span className="text-[10px] uppercase tracking-widest font-bold text-stone-400">veya</span>
          <span className="flex-1 border-t border-stone-200" />
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-[10px] uppercase tracking-[0.2em] font-bold text-stone-500 mb-2">E-posta</label>
            <input
              data-testid="login-email"
              required type="email" value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-stone-50 border border-stone-200 px-4 py-3 focus:outline-none focus:border-stone-950 focus:bg-white"
            />
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-[0.2em] font-bold text-stone-500 mb-2">Şifre</label>
            <input
              data-testid="login-password"
              required type="password" value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-stone-50 border border-stone-200 px-4 py-3 focus:outline-none focus:border-stone-950 focus:bg-white"
            />
          </div>
          <button
            data-testid="login-submit-button"
            disabled={busy}
            className="w-full bg-stone-950 text-white font-bold py-3 hover:bg-stone-800 transition-colors disabled:opacity-60"
          >
            {busy ? "Giriş yapılıyor…" : "Giriş Yap"}
          </button>
        </form>

        <p className="text-sm text-stone-500 mt-6 text-center">
          Hesabın yok mu? <Link to="/kayit" className="font-bold text-stone-950 hover:underline">Üye Ol</Link>
        </p>
      </div>
    </div>
  );
}
